// store/slices/categorySlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentCategory: null,
  categoryHistory: [],
};

const categorySlice = createSlice({
  name: 'category',
  initialState,
  reducers: {
    selectCategory: (state, action) => {
      const payloadId = String(action.payload.id);
      console.log('selectCategory: current=', state.currentCategory, 'new=', action.payload);
      if (state.currentCategory && state.currentCategory.id !== payloadId) {
          console.log('Pushing to history:', state.currentCategory);
          state.categoryHistory.push(state.currentCategory);
      }
      state.currentCategory = { ...action.payload, id: payloadId };
  },
    goBackCategory: (state) => {
      if (state.categoryHistory.length > 0) {
        state.currentCategory = state.categoryHistory.pop();
      } else {
        state.currentCategory = null;
      }
    },
    resetCategories: (state) => {
      state.currentCategory = null;
      state.categoryHistory = [];
    },
    setInitialCategory: (state, action) => {
      if (action.payload) {
        const payloadId = String(action.payload.id); // Нормализуем id в string
        state.currentCategory = { ...action.payload, id: payloadId };
      } else {
        state.currentCategory = null;
      }
      state.categoryHistory = []; // Очищаем историю при инициализации
    }
  },
});

export const { selectCategory, goBackCategory, resetCategories, setInitialCategory } = categorySlice.actions;

export default categorySlice.reducer;